import { Copy, Plus, type LucideIcon } from "lucide-react";

import {
  VIEWPORT_TOOL_KINDS,
  VIEWPORT_TOOLSET_IDS,
  VIEWPORT_TOOLSET_PLACEMENTS,
  type ViewportToolDefinition,
  type ViewportToolsetDefinition,
} from "@/viewport-tools/core/contracts";

export const TAG_TOOL_IDS = {
  add: "tags-add",
  duplicate: "tags-duplicate",
} as const;

export type TagToolId = (typeof TAG_TOOL_IDS)[keyof typeof TAG_TOOL_IDS];

export interface TagToolDefinition
  extends ViewportToolDefinition<TagToolId, typeof VIEWPORT_TOOLSET_IDS.tags> {
  icon: LucideIcon;
}

export type TagToolsetDefinition = ViewportToolsetDefinition<
  typeof VIEWPORT_TOOLSET_IDS.tags,
  TagToolId
>;

export const TAG_TOOL_DEFINITIONS: Record<TagToolId, TagToolDefinition> = {
  [TAG_TOOL_IDS.add]: {
    id: TAG_TOOL_IDS.add,
    label: "Add Tag",
    toolsetId: VIEWPORT_TOOLSET_IDS.tags,
    kind: VIEWPORT_TOOL_KINDS.toggle,
    icon: Plus,
  },
  [TAG_TOOL_IDS.duplicate]: {
    id: TAG_TOOL_IDS.duplicate,
    label: "Duplicate",
    toolsetId: VIEWPORT_TOOLSET_IDS.tags,
    kind: VIEWPORT_TOOL_KINDS.toggle,
    icon: Copy,
  },
};

export const TAG_TOOLSET: TagToolsetDefinition = {
  id: VIEWPORT_TOOLSET_IDS.tags,
  label: "Tags",
  placement: VIEWPORT_TOOLSET_PLACEMENTS.leftRail,
  tools: [TAG_TOOL_IDS.add, TAG_TOOL_IDS.duplicate],
};

export function getTagToolDefinition(toolId: TagToolId): TagToolDefinition {
  return TAG_TOOL_DEFINITIONS[toolId];
}

export function getTagToolDefinitions(
  toolset: TagToolsetDefinition = TAG_TOOLSET
): TagToolDefinition[] {
  return toolset.tools.map((toolId) => TAG_TOOL_DEFINITIONS[toolId]);
}
